export const cardsDefaultConfig = {
  isTitleUnderlined: false,
  hasBackground: false,
  isSmallTitle: true,
  fullWidth: true,
  headingLevel: 3,
  fixedHeight: true,
  hideDescription: true,
};

export const cardsPerPageDefaultConfig = {
  xsmall: 1,
  small: 2,
  medium: 3,
  large: 4,
  xlarge: 4,
};

export const carouselDefaultConfig = {
  headingLevel: 4,
  rightChevronIconSrc: '/ccx-files/assets/arrow-right.svg',
  leftChevronIconSrc: '/ccx-files/assets/arrow-left.svg',
};
